<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-24 09:51:25
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <a-tabs>
          <a-tab-pane key="1" tab="基本信息">
            <baseMessage :disabled="true" view :content="['partnerBase']" :permissionPage="permissionBase" />
          </a-tab-pane>
          <a-tab-pane key="2" tab="对接人">
            <contactsTable />
          </a-tab-pane>
          <a-tab-pane key="3" tab="市场活动">
            <partnerActivity />
          </a-tab-pane>
          <a-tab-pane key="4" tab="维护记录">
            <partnerFollowRecord />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import baseMessage from '@/views/gucangSales/marketing/partnerManage/components/baseMessage.vue'
import contactsTable from '@/views/gucangSales/marketing/partnerManage/components/contactsTable.vue'
import partnerActivity from '@/views/gucangSales/marketing/partnerManage/components/partnerActivity.vue'
import partnerFollowRecord from '@/views/gucangSales/marketing/partnerManage/components/partnerFollowRecord.vue'
const permissionBase = {
  edit: 'fbu_partner_counterpart_edit_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuPartnerManageView' }
</script>
